module.exports = __webpack_public_path__ + "img/about.474a6ab3.jpg";